<div class="dialog-title fs-20 fw-600">
    {{'SIZING.SIZING_DOCUMENTS' | transloco}}
</div>
<div class="close-icon cursor-pointer">
    <mat-icon svgIcon="close" (click)="dialogRef.close()"></mat-icon>
</div>
<div class="dialog-subtitle fs-14 fw-400">
    {{'ADD_VERSION.CAPABILITY' | transloco}} : {{ data?.capability || '-' }}
    <span class="pipe">|</span> {{ data?.component || '-' }}
</div>

<div class="divider-line"></div>

<div class="dialog-body">
    <div *ngFor="let section of data.sections" class="section">
        <div class="section-title fs-14 fw-700">{{ section.sectionTitle }}</div>
        <div class="fields-row">
            <div *ngFor="let metric of section.metrics" class="field">
                <div class="number-field">
                    <label class="field-label fs-12 fw-700">{{ metric.label }}</label>
                    <div class="number-wrapper">
                        <ng-container *ngIf="metric.enum && metric.enum.length > 0; else nonEnumField">

                            <select [(ngModel)]="metric.value" [disabled]="!metric.overrideAllowed" (ngModelChange)="checkForChanges()" class="enum-dropdown">
                                <option *ngFor="let option of metric.enum" [value]="option">
                                    {{ option }}
                                </option>
                            </select>
                        </ng-container>
                        <ng-template #nonEnumField>
                                <div class="number-input-container">
                                    <input type="number" class="input-field" min="0" [(ngModel)]="metric.value"  (ngModelChange)="checkForChanges()" [disabled]="!metric.overrideAllowed" readonly [ngClass]="[metric.error ? 'error-text': '']"/>
                                    <div class="spinner">
                                        <button type="button" [disabled]="!metric.overrideAllowed"  (mousedown)="$event.preventDefault()" (click)="increment(metric); checkForChanges()">
                                            <mat-icon class="icon-sm" svgIcon="keyboard_arrow_up"></mat-icon>
                                        </button>
                                        <button type="button" [disabled]="!metric.overrideAllowed" (mousedown)="$event.preventDefault()" (click)="decrement(metric); checkForChanges()">
                                            <mat-icon class="icon-sm" svgIcon="keyboard_arrow_down"></mat-icon>
                                        </button>
                                    </div>
									<div class="error" *ngIf="metric.error" [innerHTML]="metric.error"></div>
                                </div>
                            </ng-template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="footer-divider"></div>
<div class="dialog-footer">
    <button class="flex justify-items-center items-center cancel-btn pr-16 pl-16 pt-8 pb-8" (click)="cancel()">
        {{ 'BUTTONS.CANCEL' | transloco }}
    </button>
    <button class="flex justify-items-center spacing items-center mossgreen primary-fg pr-16 pl-16 pt-8 pb-8" (click)="!saveEnabled ? '' : save()" [ngClass]="{'disabled': !saveEnabled}">
        {{ 'BUTTONS.SAVE' | transloco }}
    </button>
</div>